/// <amd-module name="Repos/PipelineStatus/BranchStatusService" />
import { GitStatus } from "Repos/Common/Contracts/Git";
import { processGitStatusArtifactUris } from "Repos/Common/Util/Build";
import { IReadyableReadonlyObservableArray, ReadyableObservableArray } from "VSS/Core/Observable";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { getGitClient } from "./RestClient/Git";

export interface IBranchStatusService extends IVssService {
    getBranchStatus(projectId: string, repositoryId: string, refName: string): IReadyableReadonlyObservableArray<GitStatus>;
}

class BranchStatusService extends VssService implements IBranchStatusService {
    private statusByBranch: { [key: string]: ReadyableObservableArray<GitStatus> } = {};

    public getBranchStatus(projectId: string, repositoryId: string, refName: string): IReadyableReadonlyObservableArray<GitStatus> {
        const key = `${projectId}.${repositoryId}.${refName}`;
        let status = this.statusByBranch[key];
        if (!status) {
            this.statusByBranch[key] = status = new ReadyableObservableArray();

            const gitClient = getGitClient(this.pageContext);
            gitClient.getRefs(repositoryId, projectId, refName.substr("refs/".length), undefined, true).then(refs => {
                let refStatuses : GitStatus[] = [];
                if (refs && refs.length) {
                    refStatuses = refs[0].statuses;
                }
                status.push(...processGitStatusArtifactUris(this.pageContext, projectId, refStatuses));
                status.ready.value = true;
            });
        }
        return status;
    }
}

Services.add("IBranchStatusService", { serviceFactory: BranchStatusService });
